export const noAccessRoutes = [
  {
    path: '/no-access',
    component: () => import('./NoAccessView.vue'),
  },
  {
    path: '/profile-not-available',
    component: () => import('./NoAccessView.vue'),
  },
]
